import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import { LanguageSelector } from "../../components/features/LanguageSelector";
import { paths } from "../../config/paths";
import { getAssetPath } from "../../lib/assetPath";
import { useTranslation } from "../../lib/i18n";

export function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className="relative flex flex-col justify-center items-center p-[16px] gap-y-32 w-full h-full min-h-full bg-cover bg-center overflow-hidden"
      style={{
        backgroundImage: `url(${getAssetPath('logo.avif')})`,
      }}
    >
      <div className="absolute top-4 right-4 z-10">
        <LanguageSelector />
      </div>
      <div className="flex items-center gap-10 flex-col rounded-lg">
        <img
          src={`${getAssetPath('/logo_name.avif')}`}
          alt="Christian Louboutin Beaute"
          className="w-[400px] object-contain"
        />
      </div>
      <div className="flex flex-col gap-8 max-w-[800px] w-full text-xl">
        <Button
          onClick={() => navigate(paths.beautyProfiler.path)}
          className="text-xl p-8 hover:bg-white/10 hover:text-white"
        >
          {t('home.beautyProfiler')}
        </Button>
        <Button
          onClick={() => navigate(paths.looksGallery.path)}
          className="text-xl p-8 hover:bg-white/10 hover:text-white"
        >
          {t('home.looksGallery')}
        </Button>
        <Button
          onClick={() => navigate(paths.fragranceProfiler.path)}
          className="text-xl p-8 hover:bg-white/10 hover:text-white"
        >
          {t('home.fragranceProfiler')}
        </Button>
      </div>
    </div>
  );
}
